import { render, staticRenderFns } from "./confirmar-modal.vue?vue&type=template&id=6ba075ec&scoped=true"
import script from "./confirmar-modal.vue?vue&type=script&lang=js"
export * from "./confirmar-modal.vue?vue&type=script&lang=js"
import style0 from "./confirmar-modal.vue?vue&type=style&index=0&id=6ba075ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba075ec",
  null
  
)

export default component.exports